module.exports = __webpack_public_path__ + "img/86erjijianma.27b6a598.gif";